var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5906",
    "data-name": "Group 5906",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.775,
    height: 53.551,
    viewBox: "0 0 51.775 53.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3557",
    "data-name": "Path 3557",
    d: "M415.639,332.928h-12.1v10.153l4.43-4.446A31.208,31.208,0,0,1,415.639,332.928Z",
    transform: "translate(-403.539 -332.928)",
    fill: "#e25351"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(0 1.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M445.224,393.261a15.5,15.5,0,0,0-4.735-11.527,16.455,16.455,0,0,0-23.18.044L403.539,395.6v6.7l17.124-17.188a11.543,11.543,0,0,1,8.3-3.483,11.653,11.653,0,0,1,11.679,11.628,11.532,11.532,0,0,1-3.462,8.313l-16.8,16.867H424c1.039,0,2.058-.044,3.058-.115l13.42-13.47A15.607,15.607,0,0,0,445.224,393.261Z",
    transform: "translate(-403.539 -366.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M411.324,345.467l-7.785,7.816v6.581l11.075-11.115a21.474,21.474,0,1,1,30.428,30.309L436,388.137c11.817-3.852,19.316-13.408,19.316-24.939v-.155c0-10.537-6.262-19.347-16.358-23.7a26.548,26.548,0,0,0-9.175-1.6A25.383,25.383,0,0,0,411.324,345.467Z",
    transform: "translate(-403.539 -337.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M435.86,418.1a6.651,6.651,0,0,0-2.056-4.9,6.887,6.887,0,0,0-9.912.02l-20.354,20.433v6.58l23.64-23.733a2.1,2.1,0,0,1,3.354-.011,2.064,2.064,0,0,1-.057,3.291L407.146,443.2h6.675l20-20.082A6.786,6.786,0,0,0,435.86,418.1Z",
    transform: "translate(-403.539 -390.973)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.79320e20efe5a798b713639535e89331.svg";
export { ForwardRef as ReactComponent };